module.exports = __webpack_public_path__ + "static/img/10.ffaa41e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/zh/10.png
// module id = UaZW
// module chunks = 0